/*
 * Copyright © 2017 TEKTELIC Communications Inc.
 */

export default angular.module('tektelic.api.gateway', [])
    .factory('gatewayService', GatewayService)
    .name;

/*@ngInject*/
function GatewayService($http, $q, types, wsSubscriptionService) {

    var service = {
        deleteGateway: deleteGateway,
        deleteSystemGateway: deleteSystemGateway,
        getGateway: getGateway,
        saveGateway: saveGateway,
        saveGatewayMassCommissioning: saveGatewayMassCommissioning,
        enableGateway: enableGateway,
        disableGateway: disableGateway,
        getGatewayGroupGateways: getGatewayGroupGateways,
        getPaginatedGatewayGroupGateways: getPaginatedGatewayGroupGateways,
        getCustomerGateways: getCustomerGateways,
        getPaginatedCustomerGateways: getPaginatedCustomerGateways,
        getProviderGateways: getProviderGateways,
        getPaginatedProviderGateways: getPaginatedProviderGateways,
        assignGatewayToCustomer: assignGatewayToCustomer,
        unassignGatewayFromCustomer: unassignGatewayFromCustomer,
        subscribeForGatewayStateData: subscribeForGatewayStateData,
        subscribeForGatewayFskStateData: subscribeForGatewayFskStateData,
        subscribeForGatewayStatsData: subscribeForGatewayStatsData,
        getSystemGatewayByMac: getSystemGatewayByMac,
        getAllGatewayGroupGateways: getAllGatewayGroupGateways
    };

    return service;

    function getGatewayGroupGateways (gatewayGroupId) {
        var deferred = $q.defer();
        $http.get(`/api/gatewayGroup/${gatewayGroupId}/gateways`, null).then(function success(response) {
            deferred.resolve(response.data);
        }, function fail() {
            deferred.reject();
        });
        return deferred.promise;
    }

    function getPaginatedGatewayGroupGateways(gatewayGroupId, limit, page, sortField, sortDirection, filter) {
        var deferred = $q.defer();
        var path = `/api/v2/gatewayGroup/${gatewayGroupId}/gateways?limit=${limit}&page=${page}&sortField=${sortField}&sortDirection=${sortDirection}`;
        if (filter) {
            path += `&filter=${encodeURIComponent(filter)}`
        }
        $http.get(path, null).then(function success(response) {
            deferred.resolve(response.data);
        }, function fail() {
            deferred.reject();
        });
        return deferred.promise;
    }

    function getCustomerGateways (customerId) {
        var deferred = $q.defer();
        $http.get(`/api/customer/${customerId}/gateways`, null).then(function success(response) {
            deferred.resolve(response.data);
        }, function fail() {
            deferred.reject();
        });
        return deferred.promise;
    }

    function getPaginatedCustomerGateways(customerId, limit, page, sortField, sortDirection, filter) {
        var deferred = $q.defer();
        var path = `/api/v2/customer/${customerId}/gateways?limit=${limit}&page=${page}&sortField=${sortField}&sortDirection=${sortDirection}`;
        if (filter) {
            path += `&filter=${encodeURIComponent(filter)}`
        }
        $http.get(path, null).then(function success(response) {
            deferred.resolve(response.data);
        }, function fail() {
            deferred.reject();
        });
        return deferred.promise;
    }

    function getProviderGateways (providerId) {
        var deferred = $q.defer();
        $http.get(`/api/provider/${providerId}/gateways`, null).then(function success(response) {
            deferred.resolve(response.data);
        }, function fail() {
            deferred.reject();
        });
        return deferred.promise;
    }

    function getPaginatedProviderGateways(providerId, limit, page, sortField, sortDirection, filter) {
        var deferred = $q.defer();
        var path = `/api/v2/provider/${providerId}/gateways?limit=${limit}&page=${page}&sortField=${sortField}&sortDirection=${sortDirection}`;
        if (filter) {
            path += `&filter=${encodeURIComponent(filter)}`
        }
        $http.get(path, null).then(function success(response) {
            deferred.resolve(response.data);
        }, function fail() {
            deferred.reject();
        });
        return deferred.promise;
    }

    function getGateway (gatewayId) {
        var deferred = $q.defer();
        var url = '/api/gateway/' + gatewayId;
        $http.get(url, null).then(function success(response) {
            deferred.resolve(response.data);
        }, function fail() {
            deferred.reject();
        });
        return deferred.promise;
    }

    function saveGateway (gateway) {
        var deferred = $q.defer();
        var url = '/api/gateway';
        $http.post(url, gateway).then(function success(response) {
            deferred.resolve(response.data);
        }, function fail() {
            deferred.reject();
        });
        return deferred.promise;
    }

    function saveGatewayMassCommissioning(gateway) {
        var deferred = $q.defer();
        var url = '/api/gateway';
        $http.post(url, gateway, {ignoreErrors: true}).then(function success(response) {
            deferred.resolve(response.data);
        }, function fail(rejection) {
            deferred.reject(rejection);
        });
        return deferred.promise;
    }

    function enableGateway (gatewayId) {
        var deferred = $q.defer();
        var url = `/api/gateway/${gatewayId}/enable`;
        $http.post(url).then(function success() {
            deferred.resolve();
        }, function fail() {
            deferred.reject();
        });
        return deferred.promise;
    }

    function disableGateway (gatewayId) {
        var deferred = $q.defer();
        var url = `/api/gateway/${gatewayId}/disable`;
        $http.post(url).then(function success() {
            deferred.resolve();
        }, function fail() {
            deferred.reject();
        });
        return deferred.promise;
    }

    function deleteGateway (gatewayId) {
        var deferred = $q.defer();
        var url = '/api/gateway/' + gatewayId;
        $http.delete(url).then(function success() {
            deferred.resolve();
        }, function fail() {
            deferred.reject();
        });
        return deferred.promise;
    }

    function deleteSystemGateway(gatewayId) {
        var deferred = $q.defer();
        var url = '/api/system/gateway/' + gatewayId;
        $http.delete(url).then(function success() {
            deferred.resolve();
        }, function fail() {
            deferred.reject();
        });
        return deferred.promise;
    }

    function assignGatewayToCustomer(customerId, gatewayId) {
        var deferred = $q.defer();
        var url = `/api/customer/${customerId}/gateway/${gatewayId}`;
        $http.post(url).then(function success() {
            deferred.resolve();
        }, function fail() {
            deferred.reject();
        });
        return deferred.promise;
    }

    function unassignGatewayFromCustomer(gatewayId) {
        var deferred = $q.defer();
        var url = `/api/customer/gateway/${gatewayId}`;
        $http.delete(url).then(function success() {
            deferred.resolve();        }, function fail() {
            deferred.reject();
        });
        return deferred.promise;
    }

    function subscribeForGatewayStateData(gatewayId, onData) {
        var subscriptionCommand = {
            entityType: types.entityType.gateway,
            entityId: gatewayId,
            type: types.wsSubscriptionType.state
        };
        var subscriber = {
            subscriptionCommand: subscriptionCommand,
            onData: function (data) {
                if (data.data) {
                    onData(data.data);
                }
            }
        };
        return wsSubscriptionService.subscribe(subscriber);
    }

    function subscribeForGatewayFskStateData(gatewayId, onData) {
        var subscriptionCommand = {
            entityType: types.entityType.gateway,
            entityId: gatewayId,
            type: types.wsSubscriptionType.fskState
        };
        var subscriber = {
            subscriptionCommand: subscriptionCommand,
            onData: function (data) {
                if (data.data) {
                    onData(data.data);
                }
            }
        };
        return wsSubscriptionService.subscribe(subscriber);
    }

    function subscribeForGatewayStatsData(gatewayId, timewindow, onData, onReconnected) {

        var subscriptionCommand = {
            entityType: types.entityType.gateway,
            entityId: gatewayId,
            type: types.wsSubscriptionType.stats
        };
        if (timewindow.history.timewindowMs) {
            subscriptionCommand.timeWindow = timewindow.history.timewindowMs;
            subscriptionCommand.startTs = 0;
            subscriptionCommand.endTs = 0;
        } else {
            subscriptionCommand.startTs = timewindow.history.fixedTimewindow.startTimeMs;
            subscriptionCommand.endTs = timewindow.history.fixedTimewindow.endTimeMs;
            subscriptionCommand.timeWindow = 0;
        }
        var subscriber = {
            subscriptionCommand: subscriptionCommand,
            onData: function (data) {
                if (data.data) {
                    onData(data.data);
                }
            },
            onReconnected: function () {
                if (onReconnected) {
                    onReconnected();
                }
            }
        };
        return wsSubscriptionService.subscribe(subscriber);
    }

    function getSystemGatewayByMac(gatewayMac) {
        var deferred = $q.defer();

        $http.get('/api/system/gateway/mac/' + gatewayMac).then(function success(response) {
            deferred.resolve(response.data);
        }, function fail() {
            deferred.reject();
        });

        return deferred.promise;
    }

    function getAllGatewayGroupGateways(gatewayGroupId) {
        var deferred = $q.defer();

        const LIMIT = 200;
        const ORDER = 'CREATED_TIME';
        const SORT_DIRECTION = types.entityTable.sortOrder.asc.value;

        const getPaginatedGateways = (page = 0) => getPaginatedGatewayGroupGateways(gatewayGroupId, LIMIT, page, ORDER, SORT_DIRECTION);

        function createRequestsArray(count) {
            let array = [];
            for (let i = 1; i < count; i++) {
                array.push(getPaginatedGateways(i));
            }
            return array;
        }

        getPaginatedGateways().then(
            function success(response) {
                var gwGroupGateways = response.data;
                var totalGwGroupGateways = response.totalElements;
                if (totalGwGroupGateways > LIMIT) {
                    let pagesCount = Math.ceil(totalGwGroupGateways / LIMIT);
                    $q.all(createRequestsArray(pagesCount)).then(
                        (results) => {
                            var allGateways = results.reduce((arr, res) => {
                                return arr.concat(res.data);
                            }, gwGroupGateways);
                            deferred.resolve(allGateways);
                        }, () => {
                            deferred.reject();
                        }
                    )
                } else {
                    deferred.resolve(gwGroupGateways);
                }
            }, function fail() {
                deferred.reject();
            });

        return deferred.promise;
    }
}



// WEBPACK FOOTER //
// ./src/app/api/gateway.service.js